import {
    THistoryEntryData,
    THistoryEntryDataComposed,
    THistoryEntryLayerTile,
} from '../history.types';
import { canvasToLayerTiles } from './canvas-to-layer-tiles';

// create a history entry where the currently active layer changes its tiles
export function getPushableLayerChange(
    composed: THistoryEntryDataComposed,
    imageOrTiles: HTMLCanvasElement | (THistoryEntryLayerTile | undefined)[],
    extraFrameTiles?: (THistoryEntryLayerTile | undefined)[][],
): THistoryEntryData {
    const activeLayerId = composed.activeLayerId;
    const layerMap = Object.fromEntries(
        Object.entries(composed.layerMap).map(([layerId, layerItem]) => {
            if (layerId === activeLayerId) {
                const entry: {
                    tiles: (THistoryEntryLayerTile | undefined)[];
                    frameTiles?: (THistoryEntryLayerTile | undefined)[][];
                } = {
                    tiles:
                        imageOrTiles instanceof HTMLCanvasElement
                            ? canvasToLayerTiles(imageOrTiles)
                            : [...imageOrTiles],
                };
                if (extraFrameTiles && extraFrameTiles.length > 0) {
                    entry.frameTiles = extraFrameTiles;
                }
                return [layerId, entry];
            }

            return [layerId, {}];
        }),
    );
    return {
        layerMap,
    };
}
